import { render, staticRenderFns } from "./LocationsNYC.vue?vue&type=template&id=112b11c0&lang=pug&"
import script from "./LocationsNYC.vue?vue&type=script&lang=ts&"
export * from "./LocationsNYC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports